import React from "react"
import { InlineWidget } from "react-calendly"
import Image from "next/image"
import classes from "./bookingModal.module.scss"
import Modal from "react-modal"
import {cn} from '@/utils/cn'
const customStyles = {
	content: {
		position: "relative !important",
		width: "100%",
		height: "100%",
		display: "flex",
		padding: "0px",
		overflow: "auto",
		backgroundColor: "rgba(0, 0, 0, 0.4)",
		zIndex: "100",
	},
	overlay: {
		zIndex: "1000",
	},
}

const BookingModal = props => {
	const {
		modalDescription,
		meetingContact: { firstName, lastName, role, teamMemberImageUrl },
		calendarLink,
	} = props.bookMeetingData

	return (
		<Modal
			isOpen={props.modalIsOpen}
			onRequestClose={props.closeModal}
			style={customStyles}
			contentLabel="Example Modal"
			className={classes.container}
		>
			<div className={classes.main}>
				<div className={classes.ModalHeader}>
					<div className={classes.close}>
						<Image
							style={{ cursor: "pointer" }}
							onClick={props.closeModal}
							src="/icons/close.svg"
							width={30}
							height={30}
						/>
					</div>

					<div className={classes.heading}>Book a Meeting</div>

					<div className={classes.divider}></div>
				</div>
				<div className={classes.ModalContent}>
					<div className={classes.imageContainer}>
						<img
							className={cn(classes.image, 'max-h-[240px]')}
							src={teamMemberImageUrl}
							alt={firstName + " " + lastName}
							width="auto"
							height={220}
						/>
					</div>
					<div className={classes.details}>
						<div className={classes.name}>
							{firstName} {lastName}
						</div>
						<div className={classes.designation}>{role}</div>
						<div className={classes.des}>{modalDescription}</div>
					</div>
				</div>
				<div className={classes.calendly}>
					<InlineWidget styles={{ height: "900px" }} url={calendarLink} />
				</div>
			</div>
		</Modal>
	)
}

export default BookingModal
